import { type State } from 'app/common/ui-components/filter'

import { flags as org } from 'app/components/common/reports/filters/org'
import { flags as building } from 'app/components/common/reports/filters/building'
import { flags as group } from './group'

const sellPointActivity = (state: State) => {
  if (group.byProductTypeSelected(state)) {
    return org.singleOrgSelected(state) && building.singleBuildingSelected(state)
  }
  return org.singleOrgSelected(state)
}

export default sellPointActivity
